module.exports = __webpack_public_path__ + "img/Tenael_Cercle.2248596c.png";